import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  searchText: '',
};

export const vendorSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
  },
});

export default vendorSlice;
